/* FFL MX SEO/CRO Sprint 1 defensive fixes — theme copy only. Prices remain MXN; no price data is changed. */
(function () {
  'use strict';

  function humanizeSlug(slug) {
    if (!slug) return '';
    return slug
      .split('?')[0]
      .split('#')[0]
      .split('/')
      .filter(Boolean)
      .pop()
      .replace(/-/g, ' ')
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function fixDefaultTitle() {
    var titleNodes = document.querySelectorAll('.hc-product-title, h1');
    titleNodes.forEach(function (node) {
      var text = (node.textContent || '').trim();
      if (text === 'Default Title') {
        var fallback = '';
        var metaOg = document.querySelector('meta[property="og:title"]');
        if (metaOg && metaOg.content && metaOg.content.trim() !== 'Default Title') {
          fallback = metaOg.content.trim();
        }
        if (!fallback && document.title) {
          fallback = document.title.split('|')[0].trim();
        }
        if (!fallback || fallback === 'Default Title') {
          fallback = humanizeSlug(window.location.pathname);
        }
        if (fallback && fallback !== 'Default Title') {
          node.textContent = fallback;
          node.setAttribute('data-ffl-fixed', 'default-title');
        }
      }
    });
  }

  function hideBadSavings(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('.savings, [id^="savings-"], .badge');
    nodes.forEach(function (node) {
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      var hasNegativeMxn = /(?:Ahorra|Ahorro|Save)?\s*\$\s*-\s*\d/i.test(text);
      var hasNegativePercent = /-\s*\d+(\.\d+)?%/.test(text);
      if (hasNegativeMxn || hasNegativePercent) {
        node.classList.add('hidden');
        node.style.display = 'none';
        node.setAttribute('aria-hidden', 'true');
        node.setAttribute('data-ffl-fixed', 'negative-savings-mxn');
      }
    });
  }

  function dedupeText(text) {
    if (!text) return text;
    var clean = text.replace(/\s+/g, ' ').trim();
    var parts = clean.split(' ');
    if (parts.length === 2 && parts[0].toLowerCase() === parts[1].toLowerCase()) {
      return parts[0];
    }
    return clean.replace(/\b([A-Za-z0-9+.-]{2,})\s+\1\b/g, '$1');
  }

  function fixDuplicateVariantLabels(root) {
    var scope = root || document;
    var selectors = [
      '.selector-wrapper label span',
      '.swatch-label.label',
      '.swatch-label:not(img)',
      '.product-variants label',
      '.product-variants legend span'
    ];
    scope.querySelectorAll(selectors.join(',')).forEach(function (node) {
      if (!node || node.children.length > 0) return;
      var original = (node.textContent || '').trim();
      var fixed = dedupeText(original);
      if (fixed && fixed !== original) {
        node.textContent = fixed;
        node.setAttribute('data-ffl-fixed', 'duplicate-variant-label');
      }
    });
  }

  function runFixes(root) {
    fixDefaultTitle();
    hideBadSavings(root);
    fixDuplicateVariantLabels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { runFixes(document); });
  } else {
    runFixes(document);
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) runFixes(node);
      });
      if (mutation.type === 'characterData' && mutation.target && mutation.target.parentElement) {
        runFixes(mutation.target.parentElement);
      }
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
